import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActiveDirectoryAddOnApiModel, BooleanApiModel, SyncUsersResultApiModel } from '@app/api/api-models';
import { AddOnService } from '../../abstractions/add-on.service';

@Injectable()
export class ActiveDirectoryAddOnService extends AddOnService<ActiveDirectoryAddOnApiModel> {
  public readonly prefix = 'active-directory';

  public isLinkDuplicated(link: string): Observable<BooleanApiModel> {
    return this.http.get<BooleanApiModel>(`${this.apiUrl}${this.prefix}/is-link-duplicated?link=${link}`);
  }

  public syncUsers(): Observable<SyncUsersResultApiModel> {
    return this.http.post<SyncUsersResultApiModel>(`${this.apiUrl}${this.prefix}/sync-users`, {});
  }

  public update(model: ActiveDirectoryAddOnApiModel): Observable<ActiveDirectoryAddOnApiModel> {
    return this.http.put<ActiveDirectoryAddOnApiModel>(`${this.apiUrl}${this.prefix}`, model);
  }
}
